import { gql } from 'graphql-request'

import { AttachmentQueries } from './attachments.queries'

export namespace TicketCommentQueries {
  export const QUERY_KEY = 'getTicketComments'
  export function getTicketComments() {
    return gql`
      query ticketComments($filter: TicketCommentFilter) {
        ticketComments(filter: $filter) {
          id
          ticketId
          creator {
            id
            role
            fullName
          }
          createdAt
          richText
          text
          attachments {
            ...AttachmentDetails
          }
          internalOnly
          parentTicketCommentId
          externalCreatedByName
          externalCreatedByRole
          reactions {
            id
            ticketCommentId
            createdBy
            externalReactionId
            externalCreatedById
            externalCreatedByName
            emoji
            createdAt
            updatedAt
          }
          childComments {
            id
            ticketId
            creator {
              id
              role
              fullName
            }
            createdAt
            richText
            text
            attachments {
              ...AttachmentDetails
            }
            internalOnly
            externalCreatedByName
            externalCreatedByRole
            reactions {
              id
              ticketCommentId
              createdBy
              externalReactionId
              externalCreatedById
              externalCreatedByName
              emoji
              createdAt
              updatedAt
            }
          }
        }
      }
      ${AttachmentQueries.ATTACHMENT_DETAILS}
    `
  }
}
